// 盤點component

<template lang="pug">

div
  div.upper-subpanel.row
    ProgressBar
    div.upper-subpanel--without-progressbar
      SplitLayout(v-if="stage === 'selectDrug'")
        SelectBox(:mode="'onlyDrug'" slot="left")
        DrugList(slot="right")
      MultiFlow(v-if="stage === 'setFlowData'" v-on:setAllConfirmData="getAllConfirmData" :multiProgress="multiProgress" :confirmProgress="confirmProgress")
      Loader(v-if="stage === 'finish'")
  BottomButtons
    action-button(title="回主畫面" slot="button-1" @click.native="cancel")
    action-button(title="管制藥品" slot="button-3" @click.native="selectAllRestrainedMed" v-if="stage !== 'setFlowData'")
    action-button(title="一般藥品" slot="button-4" @click.native="selectAllNormalMed" v-if="stage !== 'setFlowData'")
    action-button(title="類別藥物" slot="button-4" @click.native="selectMedByGroup" v-if="stage !== 'setFlowData'")
    action-button(title="取消選擇" slot="button-7" @click.native="unCheckAll" v-if="stage !== 'setFlowData'")
    action-button(title="選擇全部" slot="button-6" @click.native="checkAll" v-if="stage !== 'setFlowData'")
    action-button(title="開始盤點" slot="button-9" @click.native="startFlow" v-if="stage !== 'setFlowData'")
    action-button(title="重設安全存量" slot="button-8" @click.native="showLowAmountModal" v-if="stage === 'setFlowData'")
  MedicineGroupSelect(v-show="modalStatus.medGroupSelect" v-on:setGroup="getGroupAndSelect")
  ConfirmModal(v-show="showInterruptModal" v-on:response="goBackInterrupt" :message="'是否繼續上次盤點進度？'")
</template>


<script>
import SelectBox from './flowComp/PositionSelection';
import DrugList from './flowComp/DrugInDeviceList';
import ProgressBar from './flowComp/ProgressBar';
import MultiFlow from './CheckAmountFlow/MultiFlow';
import Loader from './common/Loader';
import BottomButtons from './common/BottomButtons';
import MedicineGroupSelect from './flowComp/MedicineGroupSelect';
import ConfirmModal from './common/Confirm';
import SplitLayout from './SplitLayout';
import AppBase from './ComponentBase/AppBase';


export default {
  name: 'CheckAmount',
  extends: AppBase,
  components: {
    SelectBox,
    DrugList,
    ProgressBar,
    MultiFlow,
    Loader,
    BottomButtons,
    MedicineGroupSelect,
    ConfirmModal,
    SplitLayout,
  },
  data() {
    return {
      resumeDrugInDeviceList: [],
      showInterruptModal: false,
      interruptEvent: undefined,
    };
  },
  created() {
    this.stage = 'selectDrug';
    this.progress = this.setupProgress();
    this.multiProgress = this.setupMultiProgress();
    this.confirmProgress = this.setupConfirmProgress();
    this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
  },
  mounted() {
    this.checkInterruptEvent();
  },
  computed: {
    filterDrugInDeviceList() {
      return this.$store.state.drugInDevice.filterDrugInDeviceList;
    },
    modalStatus() {
      return this.$store.state.modalStatus;
    },
    sortedSelectedDrugInDevice() {
      return this.$store.state.drugInDevice.sortedSelectedDrugInDevice;
    },
    currentDrugInDevice() {
      return this.$store.getters.currentDrugInDevice;
    },
  },
  methods: {
    setupProgress() {
      const prog = [];
      prog.push({ en: 'selectDrug', zh: '選擇藥物' });
      if (this.$store.state.user.user.task_privilege.inventory_drug === false) {
        prog.push({ en: 'rxCheck', zh: '覆核動作' });
      }
      prog.push({ en: 'action', zh: '更新數量' });
      return prog;
    },
    setupMultiProgress() {
      const prog = [];
      prog.push('confirm');
      prog.push('finish');
      return prog;
    },
    setupConfirmProgress() {
      const prog = [];
      if (this.$store.state.user.user.task_privilege.inventory_drug === false) {
        prog.push('rxCheck');
      }
      prog.push('action');
      prog.push('next');
      return prog;
    },
    getGroupAndSelect(groupId) {
      this.$store.dispatch('unSelectAllDrugStorageAndDevices');
      this.$store.dispatch('selectDrugStorageByGroupId', groupId);
    },
    selectAllRestrainedMed() {
      this.$store.dispatch('unSelectAllDrugStorageAndDevices');
      this.$store.dispatch('selectAllRestrainedDrugStorage');
    },
    selectAllNormalMed() {
      this.$store.dispatch('unSelectAllDrugStorageAndDevices');
      this.$store.dispatch('selectAllNormalDrugStorage');
    },
    checkInterruptEvent() {
      this.instance.get('/api/event/', {
        params: {
          event: 'SUSPENDED_INVENTORY',
          per_page: 1,
        },
      })
      .then((res) => {
        if (res.data.results.length > 0) {
          const lastEvent = res.data.results[0];
          if (lastEvent.checked === false) {
            this.resumeDrugInDeviceList = lastEvent.number2.split('-');
            this.interruptEvent = lastEvent;
            this.showInterruptModal = true;
          }
        }
      });
    },
    goBackInterrupt(response) {
      if (response) {
        this.resumeDrugInDeviceList.forEach((id) => {
          this.$store.commit('SELECT_DRUG_IN_DEVICES_FROM_SELECTED', id);
        });
        this.startFlow();
      }
      this.instance.patch(`/api/event/${this.interruptEvent.id}/`, {
        checked: true,
      });
      this.showInterruptModal = false;
    },
    remainDrugInDevices() {
      const sortedDrugDeviceIds = [];
      this.sortedSelectedDrugInDevice.forEach((item) => {
        sortedDrugDeviceIds.push(item.id);
      });
      const currentIndex = sortedDrugDeviceIds.indexOf(this.currentDrugInDevice.id);
      if (currentIndex !== -1) {
        return sortedDrugDeviceIds.slice(currentIndex, sortedDrugDeviceIds.length).join('-');
      }
      return undefined;
    },
    cancel() {
      this.$router.push({ name: 'Main' });
      if (this.sortedSelectedDrugInDevice.length > 0 && this.stage !== 'selectDrug') {
        this.$store.dispatch('recordAction', { eventType: 'SUSPENDED_INVENTORY', number2: this.remainDrugInDevices() });
      }
      this.$store.dispatch('recordAction', { eventType: 'CANCEL_INVENTORY' });
    },
    checkAll() {
      this.$store.dispatch('selectAllDrugStorageAndDevices');
    },
    unCheckAll() {
      this.$store.dispatch('unSelectAllDrugStorageAndDevices');
    },
    async startFlow() {
      if (Object.keys(this.$store.state.drugInDevice.selectedDrugInDevice).length === 0) {
        this.$store.commit('SET_MESSAGE', { type: 'error', context: '請至少選擇一項儲存藥物' });
      } else {
        await this.$store.dispatch('fromFirstDrugInDevice');
        this.stage = 'setFlowData';
      }
    },
    async getAllConfirmData() {
      this.$store.dispatch('resetAll');
      await this.$store.dispatch('getDrugInDevices');
      await this.$store.dispatch('getSystemInfo');
      this.stage = 'selectDrug';
      this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
    },
    showLowAmountModal() {
      this.$store.commit('SHOW_MODAL', { modalName: 'lowAmount', status: true });
    },
    selectMedByGroup() {
      this.$store.commit('SHOW_MODAL', { modalName: 'medGroupSelect', status: true });
    },
  },
  watch: {
    stage(val) {
      if (val === 'selectDrug') {
        this.$store.commit('SHOW_LOGOUT', true);
      } else {
        this.$store.commit('SHOW_LOGOUT', false);
      }
    },
  },
};
</script>


<style lang="sass">


</style>



// WEBPACK FOOTER //
// CheckAmount.vue?057cf1a2